import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/gensen_01.png")